import { memo, useMemo } from "react";
import { Image } from "semantic-ui-react";

import userImageIcon from '../../assets/img/NewProfileImage.png';

const HeaderUserProfileCard = ({
  name = "",
  // role = "Student",
  userImage = ''
}) => {

  const getInitials = useMemo(() => {
    return name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .toUpperCase();
  }, [name]);

  return (
    <div className="flex items-center space-x-4 cursor-pointer">
      {/* Profile Circle */}
      {
        userImage || !getInitials?
          <Image src={userImage || userImageIcon} className="my-profile-img w-12 h-12 rounded-full object-cover" />
          : <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#1B75BC] dark:bg-[#FFFFFF] text-[#eaf1fe] font-bold text-xl">
            {getInitials}
          </div>
      }


      {/* User Info */}
      <div>
        <p className="font-semibold text-[#212121] text-xl transition-all duration-300 dark:text-[#F5F5F5] m-0">{name}</p>
        {/* <p className="text-[#212121] text-md transition-all duration-300 dark:text-[#F5F5F5] m-0">{role}</p> */}
      </div>
    </div>
  );
};

export default memo(HeaderUserProfileCard);